/* FUKUI theme — generated furniture drawings
   Shared by the product page and the made-to-order calculator.

   Every drawing is built from the piece's real width / depth / height in cm and
   takes the shape of its category. Three styles:
     iso  — isometric, drafting language (outline + dimension lines)
     tech — front and side elevation, to scale
     ortho — plan, front and side: the product page's register sheet
   Both read their data from the <svg> element:
     data-kind    floating | console | nightstand | tv | bench | coffee
     data-w/d/h   centimetres
     data-drawers 0 | 1 | 2
     data-grip    line | flat — flat (push-to-open) fronts get no grip line
     data-finish  a hex colour or a finish name, tints the faces (optional)
   Dimensions and labels are styled from CSS (.dim-sheet .o/.i/.dim/.ext/.dt/.vl). */
(function () {
  'use strict';

  /* mix a colour towards white; f = 0 keeps it, f = 1 makes it white */
  function mix(hex, f) {
    var n = parseInt(hex.slice(1), 16);
    return '#' + [(n >> 16) & 255, (n >> 8) & 255, n & 255].map(function (v) {
      return Math.round(v + (255 - v) * f).toString(16).padStart(2, '0');
    }).join('');
  }

  function finishColour(raw) {
    var s = (raw || '').toLowerCase();
    if (/^#[0-9a-f]{6}$/.test(s)) return s;
    if (s.indexOf('brown') > -1) return '#7A5230';
    if (s.indexOf('black') > -1) return '#211E1B';
    if (s.indexOf('natural') > -1) return '#C9A567';
    return null;
  }

  /* How the category is built: legs, a seat slab, a shelf.
     'box' is the neutral one — a plain solid with no base of any kind, used
     where the drawing is about the dimensions rather than the design. */
  function geom(kind, W, H) {
    var legH = 0, slabH = 0, shelfY = 0;
    if (kind === 'nightstand' || kind === 'tv') { legH = Math.min(12, H * 0.3); }
    else if (kind === 'bench') { slabH = Math.min(Math.max(H * 0.16, 4), 8); legH = H - slabH; }
    else if (kind === 'coffee') { slabH = Math.min(Math.max(H * 0.15, 4), 7); legH = H - slabH; shelfY = legH * 0.45; }
    return { legH: legH, bodyH: slabH || (H - legH), shelfY: shelfY, legT: 4,
             plain: kind === 'box',
             floating: kind === 'floating' || kind === 'console' || kind === 'box' };
  }

  function read(svg, fallbackVB) {
    var vb = (svg.getAttribute('viewBox') || fallbackVB).split(/\s+/).map(Number);
    return {
      VW: vb[2], VH: vb[3],
      W: parseFloat(svg.dataset.w) || 40,
      D: parseFloat(svg.dataset.d) || 35,
      H: parseFloat(svg.dataset.h) || 45,
      kind: svg.dataset.kind || 'floating',
      drawers: parseInt(svg.dataset.drawers || '1', 10),
      grip: svg.dataset.grip || 'line'
    };
  }

  function n(v) { return Math.round(v * 10) / 10; }

  /* ── isometric ─────────────────────────────────────────────────────────── */
  function drawIso(svg) {
    if (!svg) return;
    var o = read(svg, '0 0 640 460');
    var VW = o.VW, VH = o.VH, W = o.W, D = o.D, H = o.H, kind = o.kind, drawers = o.drawers, grip = o.grip;
    var g = geom(kind, W, H);
    var bodyH = g.bodyH, legH = g.legH, floorZ = bodyH + legH, t = Math.min(g.legT, W / 5, D / 5);
    var shelfZ = g.shelfY > 0 ? floorZ - g.shelfY : 0;

    var base = finishColour(svg.dataset.finish);
    var fTop = base ? mix(base, 0.74) : '#FCFAF6';
    var fFront = base ? mix(base, 0.62) : '#FFFFFF';
    var fSide = base ? mix(base, 0.46) : '#EFEAE1';

    var ux = [1, -0.30], uy = [0.62, 0.31];
    function pr(x, y, z) { return [x * ux[0] + y * uy[0], x * ux[1] + y * uy[1] + z]; }

    /* fit the piece plus the ground (or the wall line) into the drawing area */
    var e = g.plain ? 0 : Math.max(W, D) * 0.12;
    var probe = [pr(0, 0, 0), pr(W, 0, 0), pr(W, D, 0), pr(0, D, 0),
                 pr(0, 0, floorZ), pr(W, 0, floorZ), pr(W, D, floorZ), pr(0, D, floorZ)];
    if (g.floating) { probe.push(pr(-e, D, 0), pr(W + e, D, 0)); }
    else { probe.push(pr(-e, -e, floorZ), pr(W + e, -e, floorZ), pr(W + e, D + e, floorZ), pr(-e, D + e, floorZ)); }
    var xs = probe.map(function (p) { return p[0]; });
    var ys = probe.map(function (p) { return p[1]; });
    var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs);
    var minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);
    var boxW = Math.max(maxX - minX, 1), boxH = Math.max(maxY - minY, 1);
    var mL = 74, mR = 72, mT = 32, mB = 96;
    var s = Math.min((VW - mL - mR) / boxW, (VH - mT - mB) / boxH);
    var offX = mL + ((VW - mL - mR) - boxW * s) / 2 - minX * s;
    var offY = mT + ((VH - mT - mB) - boxH * s) / 2 - minY * s;
    function P(x, y, z) { var p = pr(x, y, z); return [p[0] * s + offX, p[1] * s + offY]; }

    function d(pts) { return 'M' + pts.map(function (p) { return n(p[0]) + ' ' + n(p[1]); }).join('L') + 'Z'; }
    function poly(pts, fill, cls) { return '<path class="' + (cls || 'o') + '" d="' + d(pts) + '" style="fill:' + fill + '"/>'; }
    function L(a, b, c) { return '<path class="' + (c || 'i') + '" d="M' + n(a[0]) + ' ' + n(a[1]) + 'L' + n(b[0]) + ' ' + n(b[1]) + '"/>'; }
    function T(x, y, str, c, a, rot) {
      var tag = '<text class="' + (c || 'dt') + '" x="' + n(x) + '" y="' + n(y) + '" text-anchor="' + (a || 'middle') + '"';
      if (rot) tag += ' transform="rotate(' + n(rot) + ' ' + n(x) + ' ' + n(y) + ')"';
      return tag + '>' + str + '</text>';
    }
    function tick(p) { return '<path class="dim" d="M' + n(p[0] - 5) + ' ' + n(p[1] + 5) + 'L' + n(p[0] + 5) + ' ' + n(p[1] - 5) + '"/>'; }
    /* a dimension parallel to one of the isometric axes */
    function dimSeg(p1, p2, off, tOff, label) {
      var q1 = [p1[0] + off[0], p1[1] + off[1]], q2 = [p2[0] + off[0], p2[1] + off[1]];
      var ang = Math.atan2(q2[1] - q1[1], q2[0] - q1[0]) * 180 / Math.PI;
      return L(p1, [p1[0] + off[0] * 1.18, p1[1] + off[1] * 1.18], 'ext') +
        L(p2, [p2[0] + off[0] * 1.18, p2[1] + off[1] * 1.18], 'ext') +
        '<path class="dim" d="M' + n(q1[0]) + ' ' + n(q1[1]) + 'L' + n(q2[0]) + ' ' + n(q2[1]) + '"/>' +
        tick(q1) + tick(q2) +
        T((q1[0] + q2[0]) / 2 + tOff[0], (q1[1] + q2[1]) / 2 + tOff[1], label, 'dt', 'middle', ang);
    }
    /* a plain vertical dimension, set out to one side */
    function dimV(yTop, yBot, x, exX, label, cls, toLeft) {
      var stop = toLeft ? x + 8 : x - 8;
      return L([exX, yTop], [stop, yTop], 'ext') + L([exX, yBot], [stop, yBot], 'ext') +
        '<path class="dim" d="M' + n(x) + ' ' + n(yTop) + 'L' + n(x) + ' ' + n(yBot) + '"/>' +
        tick([x, yTop]) + tick([x, yBot]) +
        T(x - 10, (yTop + yBot) / 2, label, cls || 'dt', 'middle', -90);
    }

    var A0 = P(0, 0, 0), B0 = P(W, 0, 0), F0 = P(W, D, 0), E0 = P(0, D, 0);
    var A1 = P(0, 0, bodyH), B1 = P(W, 0, bodyH), F1 = P(W, D, bodyH);
    var Af = P(0, 0, floorZ), Bf = P(W, 0, floorZ), Ff = P(W, D, floorZ);
    var out = '', k;

    /* what it sits on: nothing for a plain solid, the floor, or the wall */
    if (g.plain) {
      /* the volume speaks for itself */
    } else if (g.floating) {
      var w1 = P(-e, D, 0), w2 = P(W + e, D, 0);
      out += '<path class="floor" d="M' + n(w1[0]) + ' ' + n(w1[1]) + 'L' + n(w2[0]) + ' ' + n(w2[1]) + '"/>';
      for (k = 0; k <= 16; k++) {
        var wx = w1[0] + (w2[0] - w1[0]) * k / 16, wy = w1[1] + (w2[1] - w1[1]) * k / 16;
        out += '<path class="hatch" d="M' + n(wx) + ' ' + n(wy) + 'L' + n(wx - 5) + ' ' + n(wy - 8) + '"/>';
      }
    } else {
      out += poly([P(-e, -e, floorZ), P(W + e, -e, floorZ), P(W + e, D + e, floorZ), P(-e, D + e, floorZ)],
                  '#F5F1EA', 'floor');
    }

    /* legs, drawn as slender posts so they read at a glance */
    if (legH > 0) {
      out += poly([P(0, 0, bodyH), P(t, 0, bodyH), P(t, 0, floorZ), P(0, 0, floorZ)], fFront);
      out += poly([P(W - t, 0, bodyH), P(W, 0, bodyH), P(W, 0, floorZ), P(W - t, 0, floorZ)], fFront);
      out += poly([P(W, D - t, bodyH), P(W, D, bodyH), P(W, D, floorZ), P(W, D - t, floorZ)], fSide);
    }
    /* the coffee table's lower shelf, as a slab with a visible edge */
    if (kind === 'coffee' && shelfZ > 0) {
      out += poly([P(t, t, shelfZ), P(W - t, t, shelfZ), P(W - t, D, shelfZ), P(t, D, shelfZ)], fTop);
      out += poly([P(t, t, shelfZ), P(W - t, t, shelfZ), P(W - t, t, shelfZ + 2), P(t, t, shelfZ + 2)], fFront);
    }

    /* the body: top, front (facing left) and side (facing right) */
    out += poly([A0, B0, F0, E0], fTop);
    out += poly([A0, B0, B1, A1], fFront);
    out += poly([B0, F0, F1, B1], fSide);

    /* what is in the front: compartments, drawer joints, grip lines */
    if (kind === 'tv') {
      out += L(P(W / 3, 0, 0), P(W / 3, 0, bodyH));
      out += L(P(2 * W / 3, 0, 0), P(2 * W / 3, 0, bodyH));
    } else if (drawers >= 2) {
      out += L(P(0, 0, bodyH / 2), P(W, 0, bodyH / 2));
    }
    if (drawers > 0 && grip !== 'flat' && kind !== 'bench' && kind !== 'coffee' && kind !== 'tv') {
      if (drawers >= 2) {
        out += L(P(W * 0.35, 0, bodyH * 0.25), P(W * 0.65, 0, bodyH * 0.25));
        out += L(P(W * 0.35, 0, bodyH * 0.75), P(W * 0.65, 0, bodyH * 0.75));
      } else {
        out += L(P(W * 0.35, 0, bodyH * 0.5), P(W * 0.65, 0, bodyH * 0.5));
      }
    }

    /* dimensions: width and depth along their own axes, height up the side */
    out += dimSeg(Af, Bf, [0, 48], [-2.9, -9.6], 'W ' + W);
    out += dimSeg(Bf, Ff, [0, 48], [4.5, -8.9], 'D ' + D);
    out += dimV(F0[1], Ff[1], F0[0] + 48, F0[0], 'H ' + H);
    if (legH > 0.5) out += dimV(A1[1], Af[1], A0[0] - 48, A0[0], String(Math.round(legH)), 'dt sm', true);

    out += T(VW / 2, VH - 14, 'ALL DIMENSIONS IN CM', 'vl');
    svg.innerHTML = out;
  }

  /* ── front + side elevation ────────────────────────────────────────────── */
  function drawTech(svg) {
    if (!svg) return;
    var o = read(svg, '0 0 640 620');
    var VW = o.VW, VH = o.VH, W = o.W, D = o.D, H = o.H, kind = o.kind, drawers = o.drawers, grip = o.grip;
    var g = geom(kind, W, H);

    var mL = 78, mR = 72, mT = 78, mB = 112, gap = 60;
    var s = Math.min((VW - mL - mR - gap) / (W + D), (VH - mT - mB) / H);
    var fw = W * s, sw = D * s, oh = H * s, tw = fw + gap + sw;
    var fx = mL + ((VW - mL - mR) - tw) / 2;
    var y0 = mT + ((VH - mT - mB) - oh) / 2;
    var by = y0 + oh, sx = fx + fw + gap;
    var bodyPx = g.bodyH * s, legPx = g.legH * s, legW = Math.max(g.legT * s, 3);

    function R(x, y, w, h) { return '<rect class="o" x="' + n(x) + '" y="' + n(y) + '" width="' + n(w) + '" height="' + n(h) + '"/>'; }
    function L(x1, y1, x2, y2, c) { return '<path class="' + (c || 'i') + '" d="M' + n(x1) + ' ' + n(y1) + 'L' + n(x2) + ' ' + n(y2) + '"/>'; }
    function T(x, y, str, c, a, rot) {
      var tag = '<text class="' + (c || 'dt') + '" x="' + n(x) + '" y="' + n(y) + '" text-anchor="' + (a || 'middle') + '"';
      if (rot) tag += ' transform="rotate(' + rot + ' ' + n(x) + ' ' + n(y) + ')"';
      return tag + '>' + str + '</text>';
    }
    function tick(x, y) { return '<path class="dim" d="M' + n(x - 5) + ' ' + n(y + 5) + 'L' + n(x + 5) + ' ' + n(y - 5) + '"/>'; }
    function dimH(x1, x2, y, label, ey) {
      return L(x1, ey, x1, y + 8, 'ext') + L(x2, ey, x2, y + 8, 'ext') +
        '<path class="dim" d="M' + n(x1) + ' ' + n(y) + 'L' + n(x2) + ' ' + n(y) + '"/>' +
        tick(x1, y) + tick(x2, y) + T((x1 + x2) / 2, y - 10, label);
    }
    function dimV(y1, y2, x, label, ex, cls) {
      return L(ex, y1, x - 8, y1, 'ext') + L(ex, y2, x - 8, y2, 'ext') +
        '<path class="dim" d="M' + n(x) + ' ' + n(y1) + 'L' + n(x) + ' ' + n(y2) + '"/>' +
        tick(x, y1) + tick(x, y2) + T(x - 10, (y1 + y2) / 2, label, cls || 'dt', 'middle', -90);
    }
    function elev(x, wPx, isSide) {
      var out = R(x, y0, wPx, bodyPx);
      if (legPx > 0) { out += R(x, y0 + bodyPx, legW, legPx) + R(x + wPx - legW, y0 + bodyPx, legW, legPx); }
      if (!isSide) {
        if (kind === 'tv') { out += L(x + wPx / 3, y0, x + wPx / 3, y0 + bodyPx) + L(x + 2 * wPx / 3, y0, x + 2 * wPx / 3, y0 + bodyPx); }
        else if (drawers >= 2) { out += L(x, y0 + bodyPx / 2, x + wPx, y0 + bodyPx / 2); }
        if (drawers > 0 && grip !== 'flat' && kind !== 'bench' && kind !== 'coffee' && kind !== 'tv') {
          if (drawers >= 2) {
            out += L(x + wPx * 0.33, y0 + bodyPx * 0.25, x + wPx * 0.67, y0 + bodyPx * 0.25) +
                   L(x + wPx * 0.33, y0 + bodyPx * 0.75, x + wPx * 0.67, y0 + bodyPx * 0.75);
          } else {
            out += L(x + wPx * 0.33, y0 + bodyPx * 0.5, x + wPx * 0.67, y0 + bodyPx * 0.5);
          }
        }
      } else if (drawers >= 2 && kind !== 'tv' && kind !== 'bench' && kind !== 'coffee') {
        out += L(x, y0 + bodyPx / 2, x + wPx, y0 + bodyPx / 2);
      }
      if (kind === 'coffee' && g.shelfY > 0) { out += R(x + legW, by - (g.shelfY + 2) * s, wPx - 2 * legW, 2 * s); }
      return out;
    }

    var out = '', k;
    if (g.plain) {
      /* the volume speaks for itself */
    } else if (g.floating) {
      out += '<path class="floor" d="M' + n(sx) + ' ' + n(y0 - 24) + 'L' + n(sx) + ' ' + n(by + 24) + '"/>';
      for (k = y0 - 20; k < by + 24; k += 11) out += '<path class="hatch" d="M' + n(sx - 7) + ' ' + n(k + 6) + 'L' + n(sx) + ' ' + n(k) + '"/>';
      out += T(sx - 16, y0 - 32, 'WALL', 'vl', 'start');
    } else {
      out += '<path class="floor" d="M' + n(fx - 20) + ' ' + n(by) + 'L' + n(sx + sw + 20) + ' ' + n(by) + '"/>';
      for (k = fx - 16; k < sx + sw + 20; k += 11) out += '<path class="hatch" d="M' + n(k) + ' ' + n(by + 7) + 'L' + n(k + 6) + ' ' + n(by) + '"/>';
    }
    out += elev(fx, fw, false) + elev(sx, sw, true);

    var dy = by + 40;
    out += dimH(fx, fx + fw, dy, 'W ' + W, by);
    out += dimH(sx, sx + sw, dy, 'D ' + D, by);
    out += dimV(y0, by, fx - 34, 'H ' + H, fx);
    if (g.legH > 0.5) out += dimV(y0 + bodyPx, by, sx + sw + 34, String(Math.round(g.legH)), sx + sw, 'dt sm');

    out += T(fx + fw / 2, dy + 34, 'FRONT', 'vl');
    out += T(sx + sw / 2, dy + 34, 'SIDE', 'vl');
    out += T(VW / 2, VH - 14, 'ALL DIMENSIONS IN CM', 'vl');
    svg.innerHTML = out;
  }


  /* ── plan + front + side: the register sheet ───────────────────────────── */
  function drawOrtho(svg) {
    if (!svg) return;
    var o = read(svg, '0 0 640 560');
    var VW = o.VW, VH = o.VH, W = o.W, D = o.D, H = o.H, kind = o.kind, drawers = o.drawers, grip = o.grip;
    var g = geom(kind, W, H);

    var mL = 86, mR = 96, mT = 46, mB = 92, gapH = 58, gapV = 56;
    var s = Math.min((VW - mL - mR - gapH) / (W + D), (VH - mT - mB - gapV) / (D + H));
    var fw = W * s, sw = D * s, oh = H * s, pd = D * s;
    var tw = fw + gapH + sw, th = pd + gapV + oh;
    var fx = mL + ((VW - mL - mR) - tw) / 2;
    var py = mT + ((VH - mT - mB) - th) / 2;
    var y0 = py + pd + gapV, by = y0 + oh, sx = fx + fw + gapH;
    var bodyPx = g.bodyH * s, legPx = g.legH * s, legW = Math.max(g.legT * s, 3);

    function R(x, y, w, h, c) { return '<rect class="' + (c || 'o') + '" x="' + n(x) + '" y="' + n(y) + '" width="' + n(w) + '" height="' + n(h) + '"/>'; }
    function L(x1, y1, x2, y2, c) { return '<path class="' + (c || 'i') + '" d="M' + n(x1) + ' ' + n(y1) + 'L' + n(x2) + ' ' + n(y2) + '"/>'; }
    function T(x, y, str, c, a, rot) {
      var tag = '<text class="' + (c || 'dt') + '" x="' + n(x) + '" y="' + n(y) + '" text-anchor="' + (a || 'middle') + '"';
      if (rot) tag += ' transform="rotate(' + rot + ' ' + n(x) + ' ' + n(y) + ')"';
      return tag + '>' + str + '</text>';
    }
    function tick(x, y, c) { return '<path class="' + (c || 'dim') + '" d="M' + n(x - 5) + ' ' + n(y + 5) + 'L' + n(x + 5) + ' ' + n(y - 5) + '"/>'; }
    function dimH(x1, x2, y, label, ey) {
      return L(x1, ey, x1, y + 8, 'ext') + L(x2, ey, x2, y + 8, 'ext') +
        '<path class="dim" d="M' + n(x1) + ' ' + n(y) + 'L' + n(x2) + ' ' + n(y) + '"/>' +
        tick(x1, y) + tick(x2, y) + T((x1 + x2) / 2, y - 10, label);
    }
    function dimV(y1, y2, x, label, ex, cls, acc) {
      var dc = acc ? 'dim acc' : 'dim', tc = cls || 'dt';
      if (acc) tc += ' acc';
      return L(ex, y1, x - 8, y1, 'ext') + L(ex, y2, x - 8, y2, 'ext') +
        '<path class="' + dc + '" d="M' + n(x) + ' ' + n(y1) + 'L' + n(x) + ' ' + n(y2) + '"/>' +
        tick(x, y1, dc) + tick(x, y2, dc) + T(x - 10, (y1 + y2) / 2, label, tc, 'middle', -90);
    }
    function elev(x, wPx, isSide) {
      var out = R(x, y0, wPx, bodyPx);
      if (legPx > 0) { out += R(x, y0 + bodyPx, legW, legPx) + R(x + wPx - legW, y0 + bodyPx, legW, legPx); }
      if (!isSide) {
        if (kind === 'tv') { out += L(x + wPx / 3, y0, x + wPx / 3, y0 + bodyPx) + L(x + 2 * wPx / 3, y0, x + 2 * wPx / 3, y0 + bodyPx); }
        else if (drawers >= 2) { out += L(x, y0 + bodyPx / 2, x + wPx, y0 + bodyPx / 2); }
        if (drawers > 0 && grip !== 'flat' && kind !== 'bench' && kind !== 'coffee' && kind !== 'tv') {
          if (drawers >= 2) {
            out += L(x + wPx * 0.33, y0 + bodyPx * 0.25, x + wPx * 0.67, y0 + bodyPx * 0.25) +
                   L(x + wPx * 0.33, y0 + bodyPx * 0.75, x + wPx * 0.67, y0 + bodyPx * 0.75);
          } else {
            out += L(x + wPx * 0.33, y0 + bodyPx * 0.5, x + wPx * 0.67, y0 + bodyPx * 0.5);
          }
        }
      } else {
        if (drawers >= 2 && kind !== 'tv' && kind !== 'bench' && kind !== 'coffee') { out += L(x, y0 + bodyPx / 2, x + wPx, y0 + bodyPx / 2); }
        if (drawers > 0 && g.floating) { var ft = Math.min(2 * s, 9); out += L(x + wPx - ft, y0, x + wPx - ft, y0 + bodyPx); }
      }
      if (kind === 'coffee' && g.shelfY > 0) { out += R(x + legW, by - (g.shelfY + 2) * s, wPx - 2 * legW, 2 * s); }
      return out;
    }

    var out = '', k;

    /* the wall (floating pieces) or the floor (everything else) */
    if (g.plain) {
      /* the volume speaks for itself */
    } else if (g.floating) {
      out += '<path class="floor" d="M' + n(fx - 18) + ' ' + n(py) + 'L' + n(fx + fw + 18) + ' ' + n(py) + '"/>';
      for (k = fx - 14; k < fx + fw + 18; k += 11) out += '<path class="hatch" d="M' + n(k) + ' ' + n(py) + 'L' + n(k + 6) + ' ' + n(py - 7) + '"/>';
      out += '<path class="floor" d="M' + n(sx) + ' ' + n(y0 - 22) + 'L' + n(sx) + ' ' + n(by + 22) + '"/>';
      for (k = y0 - 18; k < by + 22; k += 11) out += '<path class="hatch" d="M' + n(sx - 7) + ' ' + n(k + 6) + 'L' + n(sx) + ' ' + n(k) + '"/>';
      out += T(sx - 4, y0 - 28, 'WALL', 'vl', 'end');
    } else {
      out += '<path class="floor" d="M' + n(fx - 20) + ' ' + n(by) + 'L' + n(sx + sw + 20) + ' ' + n(by) + '"/>';
      for (k = fx - 16; k < sx + sw + 20; k += 11) out += '<path class="hatch" d="M' + n(k) + ' ' + n(by + 7) + 'L' + n(k + 6) + ' ' + n(by) + '"/>';
    }

    /* plan, seen from above — the wall runs along its top edge */
    out += R(fx, py, fw, pd);
    var ins = Math.min(10, fw * 0.06, pd * 0.12);
    if (g.floating) {
      var bw = Math.min(36, fw * 0.22);
      out += R(fx + fw * 0.16, py + 3, bw, 7, 'hid') + R(fx + fw * 0.84 - bw, py + 3, bw, 7, 'hid');
    }
    if (legPx > 0) {
      out += R(fx, py, legW, legW) + R(fx + fw - legW, py, legW, legW) +
             R(fx, py + pd - legW, legW, legW) + R(fx + fw - legW, py + pd - legW, legW, legW);
    }
    if (kind === 'tv') {
      out += L(fx + fw / 3, py, fx + fw / 3, py + pd, 'hid') + L(fx + 2 * fw / 3, py, fx + 2 * fw / 3, py + pd, 'hid');
    } else if (drawers > 0 && kind !== 'bench' && kind !== 'coffee') {
      out += R(fx + ins, py + ins, fw - 2 * ins, pd - 2 * ins, 'hid');
    }
    if (kind === 'coffee' && g.shelfY > 0) { out += R(fx + legW, py + legW, fw - 2 * legW, pd - 2 * legW, 'hid'); }

    /* the two elevations */
    out += elev(fx, fw, false) + elev(sx, sw, true);

    /* dimensions: width under the front, height beside it, depth beside the plan */
    var dy = by + 38;
    out += dimH(fx, fx + fw, dy, 'W ' + W, by);
    out += dimV(y0, by, fx - 34, 'H ' + H, fx, 'dt', true);
    out += dimV(py, py + pd, fx + fw + 34, 'D ' + D, fx + fw);
    if (g.legH > 0.5) out += dimV(y0 + bodyPx, by, sx + sw + 34, String(Math.round(g.legH)), sx + sw, 'dt sm');

    out += T(fx - 16, py + pd / 2, 'PLAN', 'vl', 'middle', -90);
    out += T(fx + fw / 2, dy + 30, 'FRONT', 'vl');
    out += T(sx + sw / 2, dy + 30, 'SIDE', 'vl');
    out += T(VW / 2, VH - 10, 'ALL DIMENSIONS IN CM', 'vl');
    svg.innerHTML = out;
  }

  function redraw(svg) {
    if (!svg) return;
    if (svg.dataset.style === 'ortho') drawOrtho(svg);
    else if (svg.dataset.style === 'tech') drawTech(svg);
    else drawIso(svg);
  }

  window.FUKUIDraw = { geom: geom, mix: mix, iso: drawIso, tech: drawTech, ortho: drawOrtho, redraw: redraw };
})();
